
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { LoginSteps } from "@/components/auth/LoginSteps";
import { LanguageSwitcher } from "@/components/ui/language-switcher";

const Login = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN" && session) {
        navigate("/dashboard");
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <div className="auth-page min-h-screen flex items-center justify-center bg-[radial-gradient(at_25%_70%,#A7DCD8_15%,#8791F3_40%,#F1F6F5_70%)]">
      <Button
        variant="ghost"
        className="absolute top-4 left-4 text-[#F1F6F5] bg-[#8791F3] hover:text-[#34375B] hover:bg-[#5CC2BB] hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-1 hover:-translate-y-1 transition-all duration-200"
        onClick={() => navigate("/")}
      >
        <ArrowLeft />
        {t("hero.back")}
      </Button>

      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>
      
      <div className="container mx-auto px-4">
        <div className="w-full max-w-md mx-auto space-y-4">
          <div className="bg-white p-6 rounded-lg shadow-lg border-2 border-[#34375B]">
            <LoginSteps />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
